angular.module('zc.commonApi')

.factory 'ProjectVisitorSegment', ($resource, $q, BaseProjectCrudService) ->
  class ProjectVisitorSegment extends BaseProjectCrudService

  new ProjectVisitorSegment(
    $resource
    $q
    '/api/projects/:projectId/visitor_segments/:id'
    'visitor_segment'
    'visitor_segments'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/visitor_segment.service.coffee